import React from "react";
import { FaLightbulb, FaUsers, FaChartLine } from "react-icons/fa";

const About = ({ isDarkMode }) => {
  const sectionBackground = isDarkMode
    ? "#111827"
    : "#f8f9fa"; // Dark/Light background

  const textColor = isDarkMode ? "#f1f5f9" : "#111"; // Primary text color
  const subTextColor = isDarkMode ? "#94a3b8" : "#4b5563"; // Secondary text

  const features = [
    {
      icon: <FaLightbulb size={32} color="#F59E0B" />,
      title: "Innovative Ideas",
      description:
        "We bring creative and innovative solutions to every project we handle."
    },
    {
      icon: <FaUsers size={32} color="#4F46E5" />,
      title: "Professional Team",
      description:
        "Our team consists of highly skilled professionals to deliver excellence."
    },
    {
      icon: <FaChartLine size={32} color="#10B981" />,
      title: "Growth Focused",
      description:
        "We aim to grow your business with measurable results and insights."
    }
  ];

  return (
    <section
      id="aboutus"
      style={{
        padding: "100px 20px",
        background: sectionBackground,
        color: textColor,
        transition: "background 0.5s ease, color 0.5s ease",
      }}
    >
      {/* Section Header */}
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto 60px auto",
          textAlign: "center",
        }}
      >
        <h2 style={{ fontSize: "42px", marginBottom: "12px" }}>About Us</h2>
        <p style={{ fontSize: "16px", color: subTextColor, lineHeight: "1.8" }}>
          We are a professional digital agency delivering high-quality services
          in web development, mobile apps, automation, marketing, and creative
          production. Our mission is to empower businesses with smart solutions.
        </p>
      </div>

      {/* Features Cards */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "28px",
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        {features.map((feature, index) => (
          <div
            key={index}
            style={{
              background: isDarkMode ? "rgba(255,255,255,0.05)" : "#fff",
              borderRadius: "16px",
              padding: "28px 20px",
              boxShadow: isDarkMode
                ? "0 8px 30px rgba(0,0,0,0.6)"
                : "0 8px 20px rgba(0,0,0,0.08)",
              textAlign: "center",
              transition: "all 0.3s ease",
              cursor: "default",
            }}
          >
            <div
              style={{
                marginBottom: "18px",
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                background: isDarkMode
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(243,244,246,0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "0 auto 12px auto",
              }}
            >
              {feature.icon}
            </div>

            <h3 style={{ fontSize: "20px", marginBottom: "12px" }}>
              {feature.title}
            </h3>

            <p
              style={{
                fontSize: "14px",
                lineHeight: "1.6",
                color: isDarkMode ? "#cbd5e1" : "#4b5563",
              }}
            >
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default About;